export const UPDATE_LOCALE_CASE = 'UPDATE_LOCALE_CASE'